/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import PT from 'prop-types'
import RRPT from 'react-router-prop-types'
import hunaLite from './images/huna_lite.webp'
import featurePic from './images/featpic.webp'
import btnGoogle from './images/btn_google.webp'
import './index.scss'

import {
  androidDownloadUrl4X,
  androidLiteDownloadUrl4X,
} from '../../constants/def'
import Carousel from "../../components/Carousel";

class Home extends React.Component {
  state = {
    contactVisible: false,
  }

  componentDidMount () { }

  hideContactAlert = () => {
    this.setState({
      contactVisible: false,
    })
  }

  showContactAlert = () => {
    this.setState({
      contactVisible: true,
    })
  }

  getYear = () => new Date().getFullYear()

  render () {
    const imagesLite = [
      { id: "hunaLite", src: hunaLite },
    ];

    // 功能按钮配置
    const featureButtons = [
      { id: "google", src: btnGoogle, alt: "Google Play", onClick: () => window.open(androidDownloadUrl4X, '_blank') },
      // { id: "apple", src: btnApple, alt: "App Store" },
      // { id: "huawei", src: btnHuawei, alt: "Huawei AppGallery" },
      // { id: "android", src: btnAndroid, alt: "Android APK" },
    ];

    return (
      <div className="Home">
        <Helmet>
          <title>Welcome to Huna</title>
          <style>{`body { background-color: #F9F6FF; }`}</style>
        </Helmet>
        <div className="Home__header">
          <div className="Home__logo" />
        </div>
        <div className="Home__title">
          <p>Welcome to Huna</p>
          <div className="Home__title__content">a brand-new social experience combining interaction, exploration, and tasks!</div>
        </div>
        {/* 下半部分：白色背景功能区块 */}
        <div className="Home__features">
          <div className="Home__features-box">
            <div className="Home__CardP">
              <h3 className="Home__CardTitle">
                🌟Say Hello to Them
                <br />
              </h3>
              <p className="Home__CardContent">
                Join lively chat rooms, interact with people from all over the world in real time, share joy, and make new friends!
              </p>
            </div>
            <div className="Home__CardP">
              <h3 className="Home__CardTitle">
                🌟Care for Sea
                <br />
              </h3>
              <p className="Home__CardContent">
                Complete fun “cleanup tasks” to protect the ocean, embrace the importance of environmental care, and explore the wonders of the underwater world!
              </p>
            </div>
            <div className="Home__CardP">
              <h3 className="Home__CardTitle">
                🌟Enjoy the Chat
                <br />
              </h3>
              <p className="Home__CardContent">
                Start conversations effortlessly, share life moments with others, and dive into meaningful stories.
              </p>
            </div>
            <div className="Home__CardP">
              <h3 className="Home__CardTitle">
                🌟Share, Connect
                <br />
              </h3>
              <p className="Home__CardContent">
                In Huna, sharing is the beginning of connection. Explore others' rooms and grow together with like-minded individuals.
              </p>
            </div>
            <div className="Home__CardP">
              <h3 className="Home__CardTitle">
                🌟Finding Yourself
                <br />
              </h3>
              <p className="Home__CardContent">
                Discover a better version of yourself with a personalized leveling system and badge rewards, and enjoy the satisfaction of continuous progress.
              </p>
            </div>
            <div className="Home__CardTop">
              <div className="Home__CardTopA">
                <h1 className="Home__CardTitleH1">Huna is more than just a chat platform — it's your ideal space to explore yourself and share happiness. Join now and embark on a unique social journey!</h1>
              </div>
            </div>
          </div>
          <div className="Home__featuresbtn" >
            {featureButtons.map((button) => (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
              <img
                key={button.id}
                src={button.src}
                alt={button.alt}
                className="Home__featureBtn"
                onClick={button.onClick}
                style={{ cursor: 'pointer' }}
              />
            ))}
          </div>
          <div className="Home__featurePic">
            <img src={featurePic} alt="featurePic" />
          </div>
        </div>

        {/* 下半部分：白色背景功能区块 */}
        <div className="Home__block">
          {/* 手机展示图 */}
          <div className="Home__phoneMockup">
            <Carousel images={imagesLite} />
          </div>
          <div className="Home__block-box">
            <div className="Home__block_title">
              <div className="Home__block_title_left">
                <h3 className="Home__CardTitle">
                  Huna Voice Chat Room Lite
                </h3>
                <p>Guard the Ocean, A New Social Experience Full of Joy!</p>
              </div>
              <div className="Home__block_title_right" onClick={() => window.open(androidLiteDownloadUrl4X, '_blank')}>
                <img
                  src={btnGoogle}
                  alt="btnGoogle"
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
            <div className="Home__CardB">
              <h3 className="Home__CardTitle">
                🌊 Eco-Missions are Super Fun
                <br />
              </h3>
              <p className="Home__CardContent">Become a cleanup squad! Chat while completing ocean conservation missions and unlock beautiful marine scenes!
              </p>
            </div>
            <div className="Home__CardB">
              <h3 className="Home__CardTitle">
                💬 A New Voice Chat Social Experience
                <br />
              </h3>
              <p className="Home__CardContent">
                Join rooms and have great conversations with fellow ocean lovers about environmental protection, hobbies, and life!
              </p>
            </div>
            <div className="Home__CardB">
              <h3 className="Home__CardTitle">
                🎖️ An Addictive Progression System
                <br />
              </h3>
              <p className="Home__CardContent">
                Exclusive eco-levels + personalized badges record your green footprint, making your efforts visible!
              </p>
            </div>
            <div className="Home__CardB">
              <h3 className="Home__CardTitle">
                👫 Meet Like-Minded Eco-Allies
                <br />
              </h3>
              <p className="Home__CardContent">
                Find friends here who care about the ocean as much as you do, and protect the blue planet together!
              </p>
            </div>
            <div className="Home__CardB">
              <h3 className="Home__CardTitle">
                🔒 Enjoy Secure Socializing
                <br />
              </h3>
              <p className="Home__CardContent">
                A strict security system protects your privacy, allowing you to chat with peace of mind and enjoy a safe, relaxed social experience!
              </p>
            </div>
            <div className="Home__CardB">
              <h3 className="Home__CardTitle">
                Easy Voice Chat | Fun Environmentalism | Green Socializing
              </h3>
              <h3 className="Home__CardTitle">
                Huna Lite: Speak Up for the Ocean! Join us now!
              </h3>
            </div>
          </div>
        </div>
        {/* 页脚 */}
        <footer className="Home__footer">
          <div className="Home__footerBar">
            <a href="https://huna.live/huna/about/userAgreement">
              User Agreement
            </a>
            <a href="https://huna.live/huna/about/privacyAgreement">
              Privacy Policy
            </a>
            <div
              className="Home__contact"
              onMouseLeave={this.hideContactAlert}
              onMouseEnter={this.showContactAlert}
            >
              Contact Us
              {this.state.contactVisible && (
                <div className="Home__contactWrap">
                  Mail: report@huna.live
                  <br />
                </div>
              )}
            </div>
          </div>
          <div className="Home__companyInfo">
            {`Cloud Technology Corporation LIMITED · ${this.getYear()}`}
          </div>
        </footer>
      </div>
    )
  }
}

Home.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  history: RRPT.history.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  userAgent: PT.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  hostname: PT.string.isRequired,
}

Home.defaultProps = {}

export default connect(state => {
  const {
    env: { userAgent, hostname },
  } = state
  // console.log('state', state)
  return { userAgent, hostname }
})(Home)
